export default __webpack_public_path__ + "static/media/advantage.459a46ae.svg";